import * as React from 'react';

import {
  AppBar, createStyles, Toolbar, Typography, withStyles, WithStyles
} from '@material-ui/core';

import logo from './assets/images/hue-logo.png';

const styles = createStyles({
    navBar: {
        position: 'relative',
        backgroundColor: "#3a4a52"
    },
    logo: {
        height: "32px",
        margin: "10px"
    },
    toolBar: {
        minHeight: "60px"
    },
    serviceName: {
        fontWeight: 400
    }
})

interface Props extends WithStyles<typeof styles> { }

class NavBar extends React.Component<Props, {}> {
    public render() {
        const { classes } = this.props;
        return (
            <AppBar className={classes.navBar}>
                <Toolbar className={classes.toolBar}>
                        <img src={logo} className={classes.logo} alt="Logo" />
                        <Typography variant="title" color="inherit" className={classes.serviceName}>
                            Role Manager
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withStyles(styles)(NavBar);


// WEBPACK FOOTER //
// ./src/NavBar.tsx